import { ShopType } from 'types/shop'
import { Action, Dispatch } from 'redux'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { shopsRef } from 'firebase/index'
import { saveShopAction } from 'reducks/shop/actions'
import { push } from 'connected-react-router'

const saveShop = (shop: ShopType, shopId: string | undefined, isEditedByOwner: boolean) => {
  return async (dispatch: Dispatch<Action>) => {
    // 編集の場合、Firestoreに情報を保存
    if (shopId) {
      dispatch(showLoadingAction())
      return shopsRef
        .doc(shopId)
        .set(shop, { merge: true })
        .then(() => {
          dispatch(hideLoadingAction())
          dispatch(
            saveShopAction({
              card: undefined,
              contact: shop.contact ?? '',
              name: shop.name ?? '',
              responsible_person: shop.responsible_person,
              shop_id: shopId,
              stripe_account_id: shop.stripe_account_id,
              stripe_customer_id: shop.stripe_customer_id,
              stripe_payment_method_id: shop.stripe_payment_method_id,
              invoice_business_name: shop.invoice_business_name,
              invoice_number: shop.invoice_number,
            })
          )

          if (isEditedByOwner) {
            dispatch(push(`/account/note/complete`))
          } else {
            dispatch(push(`/admin/shops/${shopId}/account/complete`))
          }
        })
        .catch((error) => {
          console.error(error)
          dispatch(hideLoadingAction())
        })
    } else {
      // 新規登録の場合、ReduxのStoreに情報を保存
      dispatch(
        saveShopAction({
          card: undefined,
          contact: shop.contact ?? '',
          name: shop.name ?? '',
          responsible_person: shop.responsible_person,
          shop_id: '',
          stripe_account_id: shop.stripe_account_id,
          stripe_customer_id: shop.stripe_customer_id,
          stripe_payment_method_id: shop.stripe_payment_method_id,
          invoice_business_name: shop.invoice_business_name,
          invoice_number: shop.invoice_number,
        })
      )
      dispatch(push(`/admin/shops/create/information`))
    }
  }
}

export default saveShop
